// extracted by extract-css-chunks-webpack-plugin
module.exports = {"modal-text":"convert-community-member-to-org-modal__modal-text___Vf_CZ","modalText":"convert-community-member-to-org-modal__modal-text___Vf_CZ","error-icon":"convert-community-member-to-org-modal__error-icon___2s2f7","errorIcon":"convert-community-member-to-org-modal__error-icon___2s2f7"};
    if(module.hot) {
      // 1679539884545
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  